import type { PublicShare } from '../api/active/generated/quote';
import type { ActiveTransport } from '../api/active/transport';
import { mapPublicShare } from './publicShareModel';
import type { PublicSharePort } from './publicShareRuntime';

export function createPublicShareApi(
  transport: ActiveTransport,
): PublicSharePort {
  return {
    async read(token, signal, customerVersionNo) {
      const query =
        customerVersionNo === undefined
          ? ''
          : `?${new URLSearchParams({ customerVersionNo: String(customerVersionNo) })}`;
      const response = await transport.requestResponse(
        `/public/shares/${encodeURIComponent(token)}${query}`,
        {
          signal,
          cache: 'no-store',
          credentials: 'omit',
          referrerPolicy: 'no-referrer',
        },
      );
      if (!response.ok) throw new Error('公开链接读取失败');
      return mapPublicShare((await response.json()) as PublicShare);
    },
  };
}
